( (window, document) => {
  "use strict";
  let $ = window.jQuery
    , slider = $( '.vodl-landlejob-slider.pre-init' );;

  const init_lazy_slider = () => {
    slider = $( '.vodl-landlejob-slider.pre-init' );

    // Do the stuff only when slider is already there and wasn't initialized, yet.
    if ( slider.length > 0 ) {

      init_slider();

      // Remove event listener for newPage event.
      window.removeEventListener( 'newPage', init_lazy_slider, false );
    }
  };

  /**
	 * Slider inititalization.
	 */
  const init_slider = () => {

    const sliderAttr = {
      speed: 250,
      slideWidth: 220,
      minSlides: 2,
      maxSlides: 4,
      slideMargin: 15,
      infiniteLoop: false,
      hideControlOnEnd: true,
    };

    const slider_wrapper = slider.find('.vodl-landlejob-slider__carousel-wrapper-slider');
    slider_wrapper.bxSlider(sliderAttr);

    const height = slider.find('.bx-wrapper').height();
    slider.find('.bx-viewport').css('height', height);

    slider.addEventListener('touchmove', (e) => {
      e.preventDefault();
    });

    slider.removeClass('pre-init');
  };

  $(document).ready( () => {

    if ( slider.length > 0 ) {

      init_slider();

    } else  { // otherwise wait for newPage event and check again

      // Initialize event listener for lazy laendlejob-slider.
      window.addEventListener('newPage', init_lazy_slider, false);
    }
  });

})(window, document);
